import React from "react"

const Footer = () => {
  return (
    <footer className="h-16 text-center flex items-center justify-center">
      <p className="text-sm">
        <span className="opacity-50">Built by </span>
        <a
          href="https://github.com/haywhy43"
          target="_blank"
          rel="noopener noreferrer"
          className="font-semibold text-purple-900 text-base"
        >
          Ayo
        </a>{" "}
        <span className="opacity-50">with{" "}</span>
        <a
          href="https://www.gatsbyjs.org/"
          rel="noopener noreferrer"
          target="_blank"
          className="font-semibold text-purple-900"
        >
          Gatsby
        </a>
      </p>
    </footer>
  )
}

export default Footer
